import { Component, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import { Inject } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { ToastrService } from 'ngx-toastr';

import { Router } from '@angular/router';

@Component({
  selector: 'app-declaracao-details',
  templateUrl: './declaracao-details.component.html',
  styleUrls: ['./declaracao-details.component.scss']
})
export class DeclaracaoDetailsComponent implements OnInit {

  dec: any;
  id;
  show = false;
  constructor(public dialogRef: MatDialogRef<DeclaracaoDetailsComponent>,
          @Inject(MAT_DIALOG_DATA) public data: any, private db: AngularFireDatabase,
          private toastr: ToastrService, public router: Router) { }

  ngOnInit() {
    this.db.database.ref(`peddingDeclarations/imobiliaria/${this.data.id}`).once('value').then(res => {
      if (!res) {
        this.close();
      }
      console.log(res.val());
      this.dec = res.val();
      this.dec.id = res.key;
      this.id = res.key;
    });
  }

  close() {
    this.dialogRef.close();
  }

  two(x) {
    if (x.toString().length === 1) {
      return '0' + x;
    }
    return x;
  }

  formatDate(x) {
    const d = new Date(x);
    return this.two(d.getDate()) + '/' + this.two((d.getMonth() + 1)) + '/' + d.getFullYear() + ' - ' +
    this.two(d.getHours()) + ':' + this.two(d.getMinutes()) + ':' + this.two(d.getSeconds());
  }

  formatNasc(x) {
    x = x.toString();
    return x.slice(0, 2) + '/' + x.slice(2, 4) + '/' + x.slice(4);
  }

  formatIdentidade(x) {
    x = x.toString();
    return x;
    // return x.slice(0, 2) + '.' + x.slice(2, 5) + '.' + x.slice(5, 8) + '-' + x.slice(8);
  }

  negar() {
    const aux = this.dec;
    aux.id = null;
    this.db.database.ref('negatedDeclarations/imobiliaria').push(aux).then(() => {
      this.db.database.ref(`peddingDeclarations/imobiliaria/${this.id}`).remove().then(() => {
        this.toastr.error('Declaração negada!');
        this.close();
      });
    });
  }

  aprovar() {
    this.show  = true;
    // this.router.navigate(['/declaracao-final', this.dec.id]);
    let printContents, popupWin;
    const matricula = this.getMatricula();
    //printContents = document.getElementById('dec').innerHTML;
    printContents = `<div id="dec" style="margin: 3%" *ngIf="show">
    <div style="display: flex; clear: both;">
        <div style="float: left; flex: 95%;">
            <span style='font-size:30px'><b>REDE DE ENSINO TÉCNICO - RET</b></span><br>
            <span style='font-size:14px'>Entidade Mantenedora: Colégio Serrana Um Ltda.    CNPJ: 07.641.146/0001-65<br>
            <b>Autorizações:</b>   EJA (Fund. e Médio) - Resolução SEE nº 3411/2006.<br>
            Portaria SEEDUC/SUBEX/AUT n° 306/2010 - EJA/EAD - Parecer CEE n° 260/2014.<br>
            CURSOS TÉCNICOS – Processo Favorável CRRSI n° E-03/013/1975/2014 de 07/01/2015; <br>
            Parecer CEE/RJ nº 260/2014 - D.O. 17/11/2014 e Parecer CEE/RJ nº 375/2014 - D.O. 17/11/2014.<br></span>
        </div>
        <div style="float: right; margin-right: 0%;">
            <img src="assets/logo.png" height="150px" alt="">
        </div>
    </div>
    <hr>
    <br>
    <br>
    <div style="background-image: url(''); background-repeat: no-repeat;
    background-position: center; " >
    <div align="center" style="font-size: 36px;">
            DECLARAÇÃO
        </div>
        <br>
        <br>
        <p style="font-size: 20px; text-indent: 5%;">
            Declaramos para fins de comprovação de escolaridade, que o (a) aluno (a) ${this.dec.name} registro de identificação n° ${this.formatIdentidade(this.dec.identidade)}, expedido por ${this.dec.orgao}, nascido (a) em ${this.formatNasc(this.dec.nascimento)}, filho (a) de ${this.dec.mae}${this.dec.pai ? ' e ' : ''}${this.dec.pai}, encontra-se regularmente matriculado (a) e frequentando neste ano de ${this.getYear()}, o curso: <b>TÉCNICO EM TRANSAÇÕES IMOBILIÁRIAS.</b>
        </p>
        <p style="font-size: 20px;">
            <b>OBS: Matrícula nº ${matricula}</b><br/>
            <b>Cadastrado no Stic-web: ${this.getDay()}/${this.getMes()}/${this.getYear()}</b><br/>
            <b>Data de Término: ${this.getTermino()}</b>
        </p>
    
        <br>
        <div align="center" style="font-size: 20px;">
            Rio de Janeiro, ${this.getDay()} de ${this.getMonth()} de ${this.getYear()}.
            <br>
            <br>
            <br>
            <br>
            <div align="center" style="position: relative;">
              <img src="assets/assinatura.png" width="50%"  halt="" style="padding-bottom: 0">
              <div class=" position: absolute; bottom: 20px; right: 20px;">
              <span style="width: 30%; height: 2px; border: 0 none; background-color: #000; color: #000;" >____________________________________</span><br>
              Diretor<br>
              Heber Pires Junior<br>
              DOERJ 01/07/2019 - Parte I, pag.40.
              </div>
            </div>
            <br><br><br>
            . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . . .  . . . . . . . . . . . . . . . . . . . . . . . <br>
            <b>MATRIZ:</b> Avenida Feliciano Sodré, 791 - Várzea - Teresópolis/RJ<br>CEP: 25.963-026 <br>
            e-mail: pcserranamatriz@gmail.com /  <b>Tel: (21) 2643-1690.</b>
    
        </div>
    </div>
    </div>
    <div style="position: relative; right: 0px; bottom: 0px;">
    <img src="assets/frame.png" style="position: absolute; right: 0; bottom: 0;" width="70px">
    </div>`;
    popupWin = window.open('', '_blank', '');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <style>
          //........Customized style.......
          </style>
        </head> 
    <body onload="window.print();">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
    // this.close();
    this.show = false;
    const aux = this.dec;
    aux.id = null;
    aux.matricula = matricula;
    console.log(aux);
    this.db.database.ref('approvedDeclarations/imobiliaria').push(aux).then(() => {
      this.db.database.ref(`peddingDeclarations/imobiliaria/${this.id}`).remove().then(() => {
        this.toastr.success('Declaração aprovada!');
        this.close();
      });
    });
  }

  getYear() {
    const d = new Date();
    return d.getFullYear();
  }

  getDay() {
    const d = new Date();
    return String(d.getDate()).padStart(2, '0');
  }

  getMonth() {
    const d = new Date();
    const m = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho',
               'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
    return m[d.getMonth()];
  }

  getMes() {
    return String(new Date().getMonth() + 1).padStart(2, '0');
  }

  getTermino() {
    const d = new Date();
    d.setMonth(d.getMonth() + 6);
    return String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() +1).padStart(2, '0') + '/' + d.getFullYear();
  }


  getMatricula() {
    const d  = new Date();

    // tslint:disable-next-line:max-line-length
    return this.getYear().toString() + this.getMes().toString() + this.getDay().toString() + d.getHours().toString() + d.getMinutes().toString() + d.getSeconds().toString();
  }

}
